'use strict';

import '../../js-vendor/jquery/jquery.tipsy';
